export default "__VITE_ASSET__e9d9aa32__"